import React from 'react';
import { connect } from 'react-redux';
import { InView } from 'react-intersection-observer';
import type { ListingDetails } from 'srcLegacy/types/listingDetails.type';

import 'app/shared/modules/hdp/HdpForm.scss';
import Contact from 'app/shared/modules/hdp/form/Contact/Contact';
import { emitTrackInlineContactFormViewEvent } from 'app/shared/models/Clickstream/ContactClickstreamEvents';

type HdpFormProps = {
  listing: ListingDetails;
  similarListings?: Array<ListingDetails>;
  onShowSuccessModal?: () => void;
};

class HdpForm extends React.Component<HdpFormProps> {
  static defaultProps = {
    similarListings: [],
    onShowSuccessModal: (): void => {
      // noop default
    },
  };

  handleScrollToBottom = () => {
    emitTrackInlineContactFormViewEvent({ listing: this.props.listing });
  };

  render() {
    const { listing, onShowSuccessModal } = this.props;

    return (
      <div className="HdpForm" id="HdpForm">
        <Contact listing={listing} onShowSuccessModal={onShowSuccessModal} />
        {/* Handles GA tracking when user scrolls and HDP form comes into view */}
        <InView
          as="span"
          triggerOnce
          onChange={(inView) => {
            if (inView) {
              this.handleScrollToBottom();
            }
          }}
        />
      </div>
    );
  }
}

export default connect()(HdpForm);
